<template>
  <div class="content-column">
    <div
      class="card-block file-preview  q-mb-md"
      :class="'image'"
    >
      <img
        v-if="loaded && isImage"
        :src="`${imgSrc}?timestamp=${Date.now()}`"
      >
      <div v-else-if="loaded">
        <q-icon
          class="q-mr-sm"
          :name="fileIcon"
          color="grey-6"
          size="5rem"
        ></q-icon>
      </div>
    </div>
    <div>
      <div class="row q-mb-sm">
        <div class="col-5">
          <b>{{ getString('module.library.details.file.title') }}</b>
        </div>
        <div class="col-7">
          {{ fileData.title ? fileData.title : '-'}}
        </div>
      </div>
      <div class="row q-mb-sm">
        <div class="col-5">
          <b>{{ getString('module.library.details.file.altText') }}</b>
        </div>
        <div class="col-7">
          {{ fileData.alt ? fileData.alt : '-' }}
        </div>
      </div>
      <div class="row q-mb-sm">
        <div class="col-5">
          <b>{{ getString('module.library.details.file.description') }}</b>
        </div>
        <div class="col-7">
          {{ fileData.description ? fileData.description : '-'}}
        </div>
      </div>
      <div class="row q-mb-sm">
        <div class="col-5">
          <b>{{ getString('module.library.details.file.caption') }}</b>
        </div>
        <div class="col-7">
          {{ fileData.caption ? fileData.caption : '-'}}
        </div>
      </div>
    </div>
    <div class="row q-mt-lg">
      <q-btn
        @click="selectImage()"
        color="primary"
        label="select"
      />
    </div>
  </div>
</template>

<script>
import common from '@/mixins/library/common';
import EventBus from '@/event-bus';
import getString from '@/helpers/GetStrings';

export default {
  props: {
    fieldName: {
      type: String,
    },
    guid: {
      type: String,
      required: true,
    },
    fileType: {
      type: String,
      default: 'image',
    },
    field: {
      type: Object,
    },
  },
  mixins: [
    common,
  ],

  data() {
    return {
      icons: {
        mp3: 'mdi-music-box',
        pdf: 'mdi-file-pdf',
        jpg: 'image',
        jpeg: 'image',
        png: 'image',
        svg: 'image',
        tiff: 'image',
        txt: 'mdi-file-document-box-outline',
        doc: 'mdi-file-word',
        docx: 'mdi-file-word',
        gif: 'gif',
        xls: 'mdi-file-excel',
        zip: 'mdi-zip-box',
        unknown: 'mdi-file-outline',
      },
      loaded: false,
      imgSrc: null,
      fileData: {
        filename: null,
        title: null,
        alt: null,
        description: null,
        caption: null,
      },
    };
  },

  methods: {
    getString,
    selectImage() {
      EventBus.$emit('refresh-table');
      EventBus.$emit(`file-select:${this.guid}`, this.file);
    },
  },

  computed: {
    fileIcon() {
      return this.icons[this.fileData.ext] ? this.icons[this.fileData.ext] : this.icons.unknown;
    },
  },

  mounted() {
    EventBus.$on('library-table:select-row', () => this.selectImage());

    // Add an event listener which listens to selected images from the library table component.
    EventBus.$on('library-table:preview-image', (row) => {
      this.loaded = false;
      if (row.ext === 'parent') {
        return;
      }
      // if (row.type === 'file') {
      //   return;
      // }
      const file = row.location.replace('api/', '').replace('library/', '');
      this.fetchLibraryFile(file);
    });
  },

  destroyed() {
    // Clean up
    EventBus.$off('library-table:select-row');
    EventBus.$off('library-table:preview-image');
  },
};
</script>

<style lang="stylus" scoped>
.preview {
  img {
    width: 100%;
  }
}

.file-preview {
  display: flex;
  justify-content: center;
  height: 40vh;
  background-size: 20px 20px;
  background-position: 0 0, 0 10px, 10px -10px, -10px 0px;
  position: relative;

  img {
    max-width: 100%;
    max-height: 100%;
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
  }
}
</style>
